import React from 'react'
import i18next from 'i18next'
import { connect } from 'react-redux'
import { Button, Form, Row, Col, Badge } from 'react-bootstrap'
import EXIF from 'exif-js'
import hash from 'object-hash'
import imageCompression from 'browser-image-compression'
import isEmail from 'validator/lib/isEmail'
import PlaceSelect from 'src/components/system_wide/places_select'
import DateTimePicker from 'src/components/system_wide/datetime_picker'
import StyledSelect from 'src/components/system_wide/styled_select'
import SelectAgentsModal from 'src/components/system_wide/select_agents_modal'
import SelectBrandModal from 'src/components/system_wide/select_brand_modal'
import IconButton from 'src/components/system_wide/icon_button'
import DocumentPreview from 'src/components/system_wide/document_preview'
import { Trans } from 'react-i18next'
import { parseISO, isAfter, format, subDays } from 'date-fns'
import axios from 'src/lib/axios'
import DealerContacts from '../dealers/dealer_contacts'
import { getAllDealers } from 'src/store/dealers'
import SelectDealersModal from '../system_wide/select_dealers_modal'
import { getDealerBrandStatus } from '../dealers/helper'
import { getConstants } from 'src/lib/constants'

const MIME_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml']
const { t } = i18next

const mstp = state => {
  let { current_appointment, categories, pending } = state.appointments
  let { id, business_role_priority } = state.userInfo
  let { all_brands: brands } = state.brands
  let { all_users: users } = state.users
  let { all_dealers: dealers } = state.dealers

  return {
    pending,
    business_role_priority,
    user_id: id,
    appointment: current_appointment,
    categories,
    users: users.filter(user => user.brands.length > 0),
    brands,
    dealers,
  }
}
class AppointmentForm extends React.Component {
  static defaultProps = {
    type: 'engagement',
    pending: false,
    readonly: false,
    appointmentFromProps: null,
    onSave: () => {},
    closeForm: () => {},
  }

  state = {
    id: null,
    type: 'engagement',
    created_by: null,
    dealer_id: null,
    piva: '',
    business_name: '',
    date: null,
    address: '',
    brand_id: '',
    place_id: '',
    appointment_hash: '',
    note: '',
    photos: [],
    merchandise_category_id: null,
    contacts: [],
    contract: null,

    add_dealer: false,
    brand_name: '',
    errors: {},
  }

  initialHash = ''
  selectAgentsModalRef = null
  selectDealersModalRef = null
  fileInputRef = null
  previewModalRef = null
  statuses = []

  constructor(props) {
    super(props)
    this.selectAgentsModalRef = React.createRef()
    this.selectDealersModalRef = React.createRef()
    this.fileInputRef = React.createRef()
    this.previewModalRef = React.createRef()

    this.statuses = getConstants().appointment_statuses
    let appointment = props.appointmentFromProps || props.appointment
    if (appointment.id) {
      let {
        id,
        dealer_brand_id,
        type,
        created_by,
        dealer_id,
        piva,
        business_name,
        date,
        note,
        photos,
        brand_id,
        brand_name,
        place_id,
        address,
        merchandise_category_id,
        contacts,
        contract,
        status,
      } = appointment
      this.state.id = id
      this.state.dealer_brand_id = dealer_brand_id
      this.state.type = type
      this.state.created_by = created_by
      this.state.dealer_id = dealer_id
      this.state.piva = piva || ''
      this.state.business_name = business_name || ''
      this.state.date = (date && parseISO(date)) || null
      this.state.merchandise_category_id = merchandise_category_id || null
      this.state.brand_id = brand_id || ''
      this.state.brand_name = brand_name || ''
      this.state.address = address || ''
      this.state.place_id = place_id || ''
      this.state.note = note || ''
      this.state.photos = [...(photos ?? [])].map(p => ({ ...p, description: p.description || '' })) || []
      this.state.contacts = [...(contacts ?? [])]
      this.state.contract = contract
      this.state.status = status
    } else {
      this.state.type = props.type
      this.state.created_by = props.business_role_priority === 4 ? props.user_id : null
    }

    // eslint-disable-next-line no-unused-vars
    let { appointment_hash, errors, add_dealer, ...rest } = this.state
    this.initialHash = hash(rest)
    this.state.appointment_hash = this.initialHash
  }

  async componentDidMount() {
    await this.getAllDealers()
  }

  getAllDealers = async () => {
    let { date, created_by, type } = this.state
    if (!created_by || this.props.readonly === true || type === 'engagement' || !date) return
    await this.props.dispatch(
      getAllDealers({
        status_filter: 'active',
        filtered_users: [created_by],
        filtered_brands: this.props.brands.map(b => b.id),
        filter: '',
        date: format(date, 'yyyy-MM-dd'),
      })
    )
    let appointment = this.props.appointmentFromProps || this.props.appointment
    if (appointment.id) return
    if (this.props.dealers.length === 1) {
      this.setDealer(this.props.dealers[0])
    } else {
      this.setState({
        dealer_id: null,
        piva: '',
        business_name: '',
        address: '',
        place_id: '',
        contacts: [],
        dealer_brand_id: null,
        merchandise_category_id: null,
        brand_id: null,
        brand_name: '',
        errors: {},
      })
    }
  }

  updateHash = () => {
    // eslint-disable-next-line no-unused-vars
    let { appointment_hash, errors, add_dealer, ...rest } = this.state
    rest = {
      ...rest,
      photos: rest.photos.map(p => {
        let { exif, ...rest } = p
        return rest
      }),
    }
    this.setState({ appointment_hash: hash(rest) })
  }

  showSelectUserModal = () => {
    this.selectAgentsModalRef.current.show({ selected_users: [this.state.created_by] })
  }
  showSelectDealerModal = () => {
    this.selectDealersModalRef.current.show({ selected_dealers: [this.state.dealer_brand_id] })
  }

  handleChangeDate = date => {
    this.setState({ date }, async () => {
      this.updateHash()
      if (!this.state.id) {
        await this.getAllDealers()
        await this.fetchPiva(this.state.piva)
      } else {
        let status = getDealerBrandStatus(date, this.props.appointment.dealer_brand)
        if (this.state.type === 'engagement' && status === 'engaged') {
          this.setState({ errors: { date: 'engaged' } })
        } else if (this.state.type !== 'engagement' && status === 'not_engaged') {
          this.setState({ errors: { date: 'not_engaged' } })
        } else {
          this.setState({ errors: {} })
        }
      }
    })
  }

  handleChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value }, async () => {
      this.updateHash()
      if (name === 'piva') {
        this.resetDealerData()
        if (value.length === 11) {
          await this.fetchPiva(value)
        } else if (value.length >= 11) {
          let errors = { piva: 'max_length' }

          this.setState({ errors })
        }
      }
    })
  }

  setDealer = dealer => {
    const { id, piva, business_name, address, place_id, contacts, dealer_brand, merchandise_category_id } = dealer
    this.setState(
      {
        dealer_id: id,
        piva,
        business_name,
        address,
        place_id,
        contacts,
        dealer_brand_id: dealer_brand.id,
        merchandise_category_id,
        brand_id: dealer_brand.brand_id,
        brand_name: dealer_brand.brand.name,
      },
      () => this.updateHash()
    )
  }

  resetDealerData = () => {
    this.setState(
      {
        business_name: '',
        place_id: '',
        address: '',
        contacts: [],
        merchandise_category_id: null,
        add_dealer: false,
        errors: {},
      },
      () => this.updateHash()
    )
  }

  handleChangeCheckbox = ({ target: { name } }) => {
    this.setState({ [name]: !this.state[name] }, () => this.updateHash())
  }

  handledChangePlace = place => {
    let { label, value } = place ?? { label: '', value: '' }
    this.setState({ address: label, place_id: value }, () => this.updateHash())
  }
  handleSelectChange = (option, { name }) => {
    this.setState({ [name]: option ? option.value : null }, () => this.updateHash())
  }

  handleDealerContactsChange = dealer_contacts => {
    this.setState({ contacts: dealer_contacts }, () => this.updateHash())
  }

  handleChangeUser = user => {
    let { id } = user[0]
    this.setState(
      {
        created_by: id,
        brand_id: null,
        piva: '',
        brand_name: '',
      },
      () => {
        this.updateHash()
        this.resetDealerData()
        this.getAllDealers()
      }
    )
  }

  handleChangeDealer = dealers => {
    this.setDealer(dealers[0])
  }

  handleChangeBrand = brands => {
    this.setState({ brand_id: brands?.[0] ?? null }, () => {
      this.updateHash()
      if (this.state.piva.length === 11) {
        this.fetchPiva(this.state.piva)
      }
    })
  }

  handleAddPhoto = () => {
    this.fileInputRef?.current?.click()
  }

  handleFileChange = ({ target }) => {
    if (!target?.files.length) {
      return
    }

    const files = Array.from(target.files)
    const validFiles = []
    const maxSizeMB = 0.5
    let exifData = null

    for (let i = 0; i < files.length && validFiles.length < 5 - this.state.photos.length; i++) {
      const file = files[i]

      if (!MIME_TYPES.includes(file.type)) {
        continue
      }

      validFiles.push(file)
    }

    if (validFiles.length === 0) {
      return
    }

    const processFile = index => {
      if (index >= validFiles.length) return

      const fileToProcess = validFiles[index]
      const reader = new FileReader()

      const updateState = (filename, exif) => {
        this.setState(
          prevState => ({
            photos: [
              ...prevState.photos,
              {
                id: null,
                filename,
                description: '',
                exif,
              },
            ],
          }),
          () => this.updateHash()
        )
      }

      const extractExifAndProcess = fileToProcess => {
        EXIF.getData(fileToProcess, () => {
          exifData = EXIF.getAllTags(fileToProcess)
          if (fileToProcess.size > maxSizeMB * 1024 * 1024) {
            const options = {
              maxSizeMB: maxSizeMB,
              maxWidthOrHeight: 1024,
              useWebWorker: true,
            }
            imageCompression(fileToProcess, options)
              .then(compressedFile => {
                reader.onload = () => {
                  updateState(reader.result, exifData)
                  processFile(index + 1)
                }
                reader.readAsDataURL(compressedFile)
              })
              .catch(error => {
                console.error('Compression Error:', error)
                processFile(index + 1)
              })
          } else {
            reader.onload = () => {
              updateState(reader.result, exifData)
              processFile(index + 1)
            }
            reader.readAsDataURL(fileToProcess)
          }
        })
      }

      // Estrai EXIF e processa l'immagine
      extractExifAndProcess(fileToProcess)
    }

    // Inizia a processare i file dalla posizione 0
    processFile(0)

    target.value = '' // Resetta il campo di input per consentire una nuova selezione
  }

  handleChangeDescription =
    index =>
    ({ target: { name, value } }) => {
      let { photos } = this.state
      photos[index].description = value
      this.setState({ photos }, () => this.updateHash())
    }

  handleDeletePhoto = index => () => {
    let { photos } = this.state
    photos.splice(index, 1)
    this.setState({ photos }, () => this.updateHash())
  }

  handleConfirm = () => {
    // eslint-disable-next-line no-unused-vars
    let { appointment_hash, current_reference, ...rest } = this.state
    this.props.onSave({ ...rest })
  }

  isFormValid = () => {
    let {
      business_name,
      piva,
      date,
      created_by,
      brand_id,
      merchandise_category_id,
      photos,
      address,
      place_id,
      contacts,
      dealer_id,
    } = this.state

    const requiredFieldsValid =
      business_name &&
      piva &&
      date &&
      created_by &&
      brand_id &&
      merchandise_category_id &&
      address &&
      (place_id || dealer_id) &&
      contacts.length > 0 &&
      (this.props.business_role_priority === 1 || photos.length > 0)

    return requiredFieldsValid
  }

  isEmailInvalid = prop => {
    let [group, field] = prop.split('.')
    let current_value = group && field ? this.state?.[group]?.[field] ?? '' : this.state?.[group] ?? ''
    return current_value !== '' && !isEmail(current_value)
  }

  fetchPiva = async piva => {
    try {
      let { date, brand_id, created_by, type } = this.state
      if (!date || !brand_id || !created_by || piva.length !== 11 || type !== 'engagement') return
      const response = await axios.get(`/api/dealers/piva_check/${created_by}/${brand_id}/${piva}`, {
        params: { date },
      })

      let { error, dealer } = response.data
      if (error) {
        this.setState({ errors: { piva: error } })
      } else {
        if (dealer) {
          let { id, business_name, address, place_id, merchandise_category_id, contacts, dealer_brands } = dealer
          let dealer_brand = dealer_brands.find(dealer_brand => dealer_brand.brand_id === parseInt(brand_id)) ?? null
          if (dealer_brand?.affiliation_date) {
            let parsedAffiliationDate = parseISO(dealer_brand.affiliation_date)
            let parsedDate = parseISO(date)
            if (isAfter(parsedAffiliationDate, parsedDate)) {
              this.setState({ errors: { piva: 'engaged' } })
              return
            }
          }
          this.setState({
            dealer_id: id,
            business_name,
            address,
            place_id,
            merchandise_category_id,
            contacts,
            errors: {},
          })
        } else {
          this.setState({ add_dealer: true })
        }
      }
    } catch (error) {
      console.error('Errore nel controllo P.IVA:', error)
    }
  }

  renderErrors(field) {
    switch (this.state.errors[field]) {
      case 'max_length':
        return <Trans i18nKey="appointments.errors.piva.max_length">La P.IVA è troppo lunga</Trans>
      case 'engaged':
        return (
          <Trans i18nKey="appointments.errors.piva.engaged">
            P.IVA appartiene ad un dealer già associato per il brand selezionato
          </Trans>
        )
      case 'in_progress':
        return (
          <Trans i18nKey="appointments.errors.piva.in_progress">
            P.IVA appartiene ad un dealer già in fase di affiliazione per il brand selezionato
          </Trans>
        )
      case 'unauthorized_agent':
        return (
          <Trans i18nKey="appointments.errors.piva.unauthorized_agent">
            Non sei autorizzato ad accedere a questo dealer
          </Trans>
        )
      default:
        return ''
    }
  }

  renderStatus = ({ status, rejected_note, rejected_at, success_at }) => {
    const statusMap = {
      concluded: { text: this.statuses['concluded'], color: 'success', date: success_at },
      rejected: { text: this.statuses['rejected'], color: 'danger', date: rejected_at },
      pending: { text: this.statuses['pending'], color: 'warning', date: null },
    }

    const { text, color, date } = statusMap[status]

    return (
      <div className="text-center d-flex flex-row">
        <Badge bg={color} className="px-3 py-2 text-uppercase shadow-sm" style={{ fontSize: '1rem' }}>
          {text}
          {date && (
            <div className="small mt-1">
              <em>{format(parseISO(date), 'dd/MM/yyyy')}</em>
            </div>
          )}
        </Badge>
        {status === 'rejected' && rejected_note && (
          <div className="text-muted small mt-1 px-2">
            <em>{rejected_note}</em>
          </div>
        )}
      </div>
    )
  }

  render() {
    let { users, business_role_priority, categories, pending, brands, dealers } = this.props
    let {
      type,
      id,
      created_by,
      piva,
      business_name,
      date,
      address,
      brand_id,
      place_id,
      note,
      merchandise_category_id,
      photos,
      errors,
      add_dealer,
      contacts,
      dealer_id,
      brand_name,
    } = this.state
    let { readonly } = this.props
    let appointment = this.props.appointmentFromProps || this.props.appointment
    let disabled_in_edit = id !== null
    let place_selected = { label: address, value: place_id }
    let categoryOptions = categories
      .filter(category => category.id === merchandise_category_id || category.is_valid === true)
      .map(c => ({ label: c.name, value: c.id }))
    let selected_category = categoryOptions.find(c => c.value === merchandise_category_id) ?? null

    let created_by_user = users.find(u => u.id === created_by)
    let disable_piva = readonly || !date || !created_by_user || !brand_id || disabled_in_edit || type !== 'engagement'
    return (
      <>
        <div className="flex-fill position-relative overflow-auto">
          <div className="container">
            <Row>
              <Form.Group as={Col} sm="12" md="4" className="mt-3 mb-3">
                <Form.Label>
                  <Trans i18nKey="components.appointments.date_appointment">Data visita</Trans>
                  <span> *</span>
                </Form.Label>
                <DateTimePicker
                  value={date}
                  onChange={this.handleChangeDate}
                  minDate={subDays(new Date(), 30)}
                  disabled={readonly}
                  isInvalid={'date' in errors}
                />
                <Form.Control.Feedback type="invalid">{this.renderErrors('date')}</Form.Control.Feedback>
              </Form.Group>
              {business_role_priority !== 4 && (
                <Form.Group as={Col} sm="6" md="4" className="mt-3 mb-3">
                  <>
                    <Form.Label>
                      <Trans i18nKey="components.appointments.officer">Funzionario</Trans>
                      <span> *</span>
                    </Form.Label>
                    <div className="mt-1 d-flex flex-row align-items-center mb-3">
                      <div className="d-flex flex-row align-items-center">
                        {(readonly === true || disabled_in_edit === true) && <b>{appointment?.created_by_name}</b>}

                        {readonly === false && business_role_priority === 1 && disabled_in_edit === false && (
                          <>
                            {created_by && (
                              <div className="text-muted me-2">
                                <b>{created_by_user?.first_name ?? ''}</b> <b>{created_by_user?.last_name ?? ''}</b>
                              </div>
                            )}
                            {!created_by && (
                              <div className="text-muted me-2">
                                <em>
                                  {t(
                                    'components.appointments.no_selected_officer_label',
                                    'Nessun funzionario selezionato'
                                  )}
                                </em>
                              </div>
                            )}
                            <Button onClick={this.showSelectUserModal}>
                              <i className="fas fa-plus fa-fw text-start me-0"></i>
                              {created_by && <Trans i18nKey="components.appointments.edit">Modifica</Trans>}
                              {!created_by && <Trans i18nKey="components.appointments.choose">Seleziona</Trans>}
                            </Button>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                </Form.Group>
              )}
              {type === 'engagement' && (
                <Form.Group as={Col} sm="6" md="4" className="mt-3 mb-3">
                  <SelectBrandModal
                    user_id={created_by}
                    required={true}
                    disabled={business_role_priority === 1 && !created_by}
                    selected={brand_id ? [brand_id] : []}
                    onChange={this.handleChangeBrand}
                    multiSelection={false}
                    readonly={readonly || disabled_in_edit === true}
                  />
                </Form.Group>
              )}
              {type !== 'engagement' && (
                <Form.Group as={Col} sm="6" md="4" className="mt-3 mb-3">
                  <Form.Label>
                    <Trans i18nKey="components.appointments.dealer">Dealer</Trans>
                    <span> *</span>
                  </Form.Label>
                  <div className="mt-1 d-flex flex-row align-items-center mb-3">
                    <div className="d-flex flex-row align-items-center">
                      <>
                        <div className="text-muted me-2">
                          {dealer_id && (
                            <b>
                              <Badge bg="primary">{brand_name}</Badge> {business_name} <br />
                            </b>
                          )}
                          {!dealer_id && (
                            <em>{t('components.appointments.no_selected_dealer', 'Nessun dealer selezionato')}</em>
                          )}
                        </div>
                        {readonly === false && disabled_in_edit === false && (
                          <Button onClick={this.showSelectDealerModal} disabled={created_by === null}>
                            <i className="fas fa-plus fa-fw text-start me-0"></i>
                            {dealer_id && <Trans i18nKey="components.appointments.edit">Modifica</Trans>}
                            {!dealer_id && <Trans i18nKey="components.appointments.choose">Seleziona</Trans>}
                          </Button>
                        )}
                      </>
                    </div>
                  </div>
                </Form.Group>
              )}
            </Row>
            <Row>
              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.appointments.piva">Partita IVA</Trans>
                  <span> *</span>
                </Form.Label>
                <Form.Control
                  name="piva"
                  placeholder={t('components.appointments.piva', 'Partita IVA')}
                  value={piva}
                  disabled={disable_piva}
                  onChange={this.handleChange}
                  isInvalid={'piva' in errors}
                />
                <Form.Control.Feedback type="invalid">{this.renderErrors('piva')}</Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.appointments.business_name">Ragione sociale</Trans>
                  <span> *</span>
                </Form.Label>
                <Form.Control
                  name="business_name"
                  placeholder={t('components.appointments.business_name', 'Ragione sociale')}
                  value={business_name}
                  disabled={!add_dealer || readonly || disabled_in_edit}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col} md="4" className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.appointments.category">Categoria merceologica</Trans>
                  <span> *</span>
                </Form.Label>

                <StyledSelect
                  name="merchandise_category_id"
                  isClearable
                  placeholder={t('components.appointments.category', 'Categoria merceologica')}
                  value={selected_category}
                  onChange={this.handleSelectChange}
                  options={categoryOptions}
                  disabled={!add_dealer || readonly || disabled_in_edit}
                />
              </Form.Group>
            </Row>

            <Row>
              <Form.Group as={Col} className="mb-4 col-12">
                <Form.Label>
                  <Trans i18nKey="components.appointments.address">Indirizzo</Trans>
                  <span> *</span>
                </Form.Label>
                <PlaceSelect selected={place_selected} onChange={this.handledChangePlace} disabled={!add_dealer} />
              </Form.Group>
            </Row>
            <Row>
              <Col>
                <DealerContacts
                  readonly={this.props.readonly}
                  dealerContacts={contacts}
                  onChange={this.handleDealerContactsChange}
                  notEditable={business_role_priority !== 1}
                />
              </Col>
            </Row>
            {(readonly === false || (readonly === true && photos.length > 0)) && (
              <Row>
                <Form.Group as={Col} sm="12" className="mt-3 mb-3 d-flex flex-row align-items-center">
                  <Form.Label className="d-flex flex-row align-items-center">
                    <Trans i18nKey="components.appointments.photos">Foto visita</Trans>
                    {business_role_priority !== 1 && <span> *</span>}

                    {readonly === false && (
                      <Button onClick={this.handleAddPhoto} className="ms-2" disabled={photos.length >= 5}>
                        <i className="fas fa-plus fa-fw text-start me-0"></i>
                        <Trans i18nKey="buttons.add">Aggiungi</Trans>
                      </Button>
                    )}
                  </Form.Label>
                  <Form.Control
                    ref={this.fileInputRef}
                    style={{ maxWidth: '1px' }}
                    type="file"
                    className="invisible"
                    multiple
                    disabled={readonly}
                    onChange={this.handleFileChange}
                  />
                </Form.Group>
                {photos.map((photo, index) => {
                  let { id, name, filename, description } = photo
                  let url = id ? `api/appointments/${id}/image` : filename
                  let title = name ? name : `Foto ${index + 1}`

                  return (
                    <div key={index} className="d-flex align-items-center mb-1">
                      <div className="me-1">
                        <img
                          src={url}
                          alt={title}
                          className="img-thumbnail"
                          style={{ maxHeight: '6rem', maxWidth: '6rem' }}
                          onClick={() =>
                            this.previewModalRef.current.showModal({
                              url,
                              mime_type: 'image/*',
                              title,
                            })
                          }
                        />
                      </div>
                      <Form.Control
                        name="note"
                        as="textarea"
                        className="flex-grow-1 h-100"
                        placeholder={t('components.appointments.add_description', 'Aggiungi una descrizione...')}
                        value={description}
                        onChange={this.handleChangeDescription(index)}
                        disabled={readonly}
                      />
                      {readonly === false && (
                        <IconButton
                          className="ms-2"
                          variant="danger"
                          icon="fas fa-trash"
                          onClick={this.handleDeletePhoto(index)}
                        />
                      )}
                    </div>
                  )
                })}
              </Row>
            )}

            <Row>
              <Form.Group as={Col} className="mb-3">
                <Form.Label>
                  <Trans i18nKey="components.appointments.note">Note</Trans>
                </Form.Label>
                <Form.Control
                  name="note"
                  as="textarea"
                  rows={5}
                  placeholder={t('components.appointments.note', 'Note')}
                  value={note}
                  onChange={this.handleChange}
                  disabled={readonly}
                />
              </Form.Group>
            </Row>
          </div>
        </div>
        <div className="border-top pt-2 d-flex flex-row justify-content-between align-items-center">
          <div>{appointment?.id && this.renderStatus(appointment)}</div>
          <div>
            {readonly === false && (
              <Button
                className="float-end"
                variant="primary"
                disabled={!this.isFormValid() || this.initialHash === this.state.appointment_hash || pending}
                onClick={this.handleConfirm}>
                <Trans i18nKey="buttons.confirm">Conferma</Trans>
              </Button>
            )}
            <Button className="float-end me-2" variant="secondary" onClick={this.props.closeForm}>
              {readonly === false && <Trans i18nKey="buttons.cancel">Annulla</Trans>}
              {readonly === true && <Trans i18nKey="buttons.close">Chiudi</Trans>}
            </Button>
          </div>
        </div>
        <SelectAgentsModal
          ref={this.selectAgentsModalRef}
          users={users}
          readonly={readonly}
          onChange={this.handleChangeUser}
          brands={brands}
        />
        <SelectDealersModal
          ref={this.selectDealersModalRef}
          date={date}
          dealers={dealers}
          readonly={readonly}
          onChange={this.handleChangeDealer}
          brands={brands}
          hideColumns={['agent']}
        />

        <DocumentPreview ref={this.previewModalRef} />
      </>
    )
  }
}

export default connect(mstp, null, null, { forwardRef: true })(AppointmentForm)
